import { Avatar, Card, List, Space } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

import { UserHoverCard } from '@/components'
import { UserListModal } from '@/components/users-list'
import { useGetUserFollowedUsersQuery, useGetUserFollowingUsersQuery } from '@/generated/graphql'
import { routes } from '@/routes'

import s from './user-manage.module.less'

interface FollowListUserProps {
  type: 'following' | 'followed'
  userId?: number
  title: string
}

export const UserManageUser: React.FC<FollowListUserProps> = ({ type, userId, title }) => {
  const query = {
    following: useGetUserFollowingUsersQuery,
    followed: useGetUserFollowedUsersQuery,
  }[type]

  const { data, loading, error } = query({
    fetchPolicy: 'no-cache',
    variables: {
      userId: userId,
      pagination: {
        last: 14,
      },
    },
  })

  if (error) {
    return null
  }

  const edges = data ? data.user.users.edges : []

  const totalCount = data ? data.user.users.totalCount : 0

  const users = edges
    .map(({ node }) => node)
    .slice()
    .reverse()

  const list = (
    <List
      loading={loading}
      grid={{ gutter: 16, column: 6 }}
      dataSource={users}
      renderItem={(g) => (
        <List.Item>
          <Space direction='vertical'>
            <Link key={g.userId} to={routes.users.page(g.userId)}>
              <Avatar src={g.avatarUrl} />
            </Link>
            <UserHoverCard email={g.email}>
              <Link to={routes.users.page(g.userId)}>{g.name}</Link>
            </UserHoverCard>
          </Space>
        </List.Item>
      )}
    />
  )

  const cardTitle = (
    <UserListModal title={title} type={type} userId={userId!}>
      <div className={s.cardTitle}>{title + ` · ${totalCount}`}</div>
    </UserListModal>
  )

  return <Card title={cardTitle}>{list}</Card>
}
